import types from './confirmTypes';

export const changeConfirmStatus = status => ({
  type: types.CHANGE_CONFIRM_STATUS,
  payload: status,
});
